import feathersClient from "../../feathers-client";

export default {
	namespaced:true,
	state:{
		masterShiftTime:[],
	},
	getters:{

	},
	mutations:{
		SET_MASTER_SHIFT_TIMES:(state,data) => {state.masterShiftTime = data;},
	},
	actions:{
		getAllMasterShiftTime:async({rootGetters,commit},filter) =>{
			const results = await feathersClient.service('/api/v3/master-shift-times').find({
				query:{
					$role:rootGetters.currentUserRole,
					$paginate:false,
					...filter,
				}
			});
			commit('SET_MASTER_SHIFT_TIMES',results);
			return results;
		},
		createMasterShiftTime: async ({rootGetters},data)=>{
			const results = await feathersClient.service('/api/v3/master-shift-times').create(data,{
				query:{
					$role:rootGetters.currentUserRole
				}
			});
		return results
		},
		updateMasterShiftTime: async ({rootGetters},data)=>{
			const id = data.id
			delete data.id
			const results = await feathersClient.service('/api/v3/master-shift-times').patch(id,data,{
				query:{
					$role:rootGetters.currentUserRole
				}
			});
		return results
		},
		deleteMasterShiftTime: async ({rootGetters},id)=>{
			const results = await feathersClient.service('/api/v3/master-shift-times').remove(id,{
				query:{
					$role:rootGetters.currentUserRole
				}
			});
		return results
		}
	}
}
